import type {ExtraPropsType} from 'types/general';
import type {DyRequestDataType} from 'types/dy';
import type {EmblaOptionsType} from 'embla-carousel';

export const EXTRA_CAROUSEL_PROPS: ExtraPropsType = {};
export const DY_REQUEST_RECOMMENDATIONS_DATA: DyRequestDataType = {
    selectors: ['D_Exit_Recommendations'],
    context: {page: {type: 'OTHER'}},
};
export const EMBLA_OPTIONS: EmblaOptionsType = {align: 'start'};
export const SLIDES_SHOWN = 3;
